export const TIMEOUT = 5000;
export const BASE_URL = '/api';

export const TOKEN_NAME = process.env.VUE_APP_TOKEN_NAME || 'burdatoken';

export const TRELLO_BASE_URL = 'https://trello.com/c';
